import type {GetStateFunc} from "../store";


export const ActionUtil = {
  getToken
}

/**
 * Helper function to fetch authentication token from state.
 * @param getState 'getState' redux function.
 * @param actionName name of the associated action (for logging purposes).
 */
function getToken(getState: GetStateFunc, actionName: string): string | null {
  const state = getState()
  const {auth} = state
  const {token} = auth

  if (!token) {
    console.info(`cancelling action '${actionName}' - no auth token available`)
  }

  return token
}
